interface IConfigurationParameter {
  key: string;
  value: string;
}

declare const window: {
  vt: {
    config: IConfigurationParameter[];
  };
};

export class ConfigurationService {
  public static get(key: string): string | undefined {
    try {
      if (!window.vt.config) {
        return undefined;
      }

      const parameters = window.vt.config as IConfigurationParameter[];

      const translationEntry = parameters.find((p) => p.key === key);

      return translationEntry?.value;
    } catch {
      return undefined;
    }
  }
}
